// redux/slices/loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  message: ''
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = true;
      state.message = action.payload || 'Cargando...';
    },
    hideLoading: (state) => {
      state.isLoading = false;
      state.message = '';
    }
  }
});

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;